import WorkoutPages from "@/components/WorkoutProfiles/WorkoutPages/WorkoutPages";
import { useSearchParams } from "react-router-dom";

const WorkoutPagesPage = () => {
  const [searchParams] = useSearchParams();
  const openAsDrawer = searchParams.get("drawer") === "true";
  return <WorkoutPages openAsDrawer={openAsDrawer} />;
};

export default WorkoutPagesPage;
